import { MenuConfig } from '#/service/config/config.types';

export enum HeaderMode {
  /** Logo and all the configured menu items */
  Default = 'DEFAULT',
  /** Logo and login & registration link items. Mainly for the unauthenticated home page. */
  Reduced = 'REDUCED',
  /** Only logo. For modals and flows. */
  Empty = 'EMPTY',
}

export interface HeaderProps {
  /** The menu data */
  menu: MenuConfig;
  /** Set the menu collapsed, regardless of scroll position */
  alwaysCollapsed?: boolean;
  /** Prefix for the menuitem caching */
  cacheKey?: string;
  /** Whether to show the unauthenticated home page header (transparent on scroll top, empty menu) */
  shouldShowUnauthenticatedHomePage?: boolean;
  /** Override the header mode */
  overrideMode?: HeaderMode;
}
